import { Box, Typography } from "@mui/material";
import { useState } from "react";

interface Stop {
  label: string;
  address: string;
}

const TripProgressBar = ({ showMap, isMobile, stopsCovered }: { showMap: boolean; isMobile: boolean; stopsCovered: any }) => {
  // const stops: Stop[] = [
  //   { label: "Source", address: "Central Warehouse, New Delhi" },
  //   { label: "Stop 1", address: "NH 44, Near Agra Cantt Railway Station, Agra" },
  //   { label: "Stop 2", address: "Plot No. 45, HITEC City Road, Hyderabad" },
  //   { label: "Destination", address: "Retail Store, Bangalore" },
  // ];

  // const [stops, setStops] = useState<any>();
  console.log("stopsCovered", stopsCovered);
  const isVertical = showMap || isMobile; // Make vertical for both showMap and mobile

  return (
    <Box
      className={`relative flex ${isVertical ? "flex-col items-start" : "flex-row items-center"} w-full p-4 mt-4`}
    >
      {/* Progress Line */}
      <Box
        className="absolute bg-gray-300"
        style={{
          width: isVertical ? "4px" : "74%",
          height: isVertical ? "70%" : "4px",
          top: isVertical ? "33px" : "25%",
          left: isVertical ? "26px" : "13%",
          transform: isVertical ? "translateX(0)" : "translateY(-50%)",
        }}
      />

      {stopsCovered?.address?.map((stop: any, index: any) => {
        const isSource = stop.addressType === "Source";
        const isDestination = stop.addressType === "Destination";

        return (
          <Box
            key={index}
            className={`relative flex ${isVertical ? "flex-row items-center" : "flex-col items-center"} ${
              isVertical ? "mb-12" : "mx-auto flex-1"
            }`}
          >
            {/* Stop Indicator (Dot) */}
            <Box
              className={`w-6 h-6 rounded-full flex items-center justify-center text-white font-bold ${
                isSource || isDestination ? "bg-black" : "bg-gray-400"
              }`}
            >
              {isSource ? "S" : isDestination ? "D" : ""}
            </Box>

            {/* Stop Details */}
            <Box className={`mt-2 ${isVertical ? "ml-4 text-left" : "text-center"}`}>
              <Typography variant="body1" className="font-semibold">
                {stop.addressType}
              </Typography>
              <Typography variant="body2" className="text-gray-500">
                {stop.addressName}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default TripProgressBar;
